import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-725756ed"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "authority"
};
import { onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { dispatchAction } from '@/store/utils';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var checkParams = computed(function () {
      return {
        bizId: route.params.biz_url,
        appKey: route.params.project
      };
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatchAction('user', 'getUserDetail', {});

            case 2:
              _context.next = 4;
              return dispatchAction('user', 'checkBizAdmin', checkParams.value);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    watch(function () {
      return checkParams.value;
    }, function () {
      dispatchAction('user', 'checkBizAdmin', checkParams.value);
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view)]);
    };
  }
});